import { render, staticRenderFns } from "./ManterMaterialView.vue?vue&type=template&id=e9a5fa56"
import script from "./ManterMaterialView.vue?vue&type=script&lang=js"
export * from "./ManterMaterialView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports